import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon, IconProps} from '../../../libs/shared/ui/src/components/icon/icon';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {makeSizeConstants} from '../../../libs/shared/ui/src/styles/styleHelpers';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';

const SIZE_VALUES = makeSizeConstants(
  {
    box: 32,
    icon: 16,
  },
  {
    box: 40,
    icon: 20,
  },
  {
    box: 48,
    icon: 24,
  },
);

export interface BoxedIconProps extends Omit<IconProps, 'size'> {
  backgroundColor?: string;
  borderColor?: string;
  size?: VisualSizesEnum;
  iconClassName?: string;
  borderStyle?: string;
}

const BoxedIconWrapperDiv = styled.div<{
  $borderColor?: string;
  $backgroundColor: string;
  $size: number;
  $borderStyle: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${(p) => p.$size / 2}px;
  height: ${(p) => p.$size}px;
  width: ${(p) => p.$size}px;
  box-sizing: border-box;
  background-color: ${(p) => p.$backgroundColor};
  ${(p) => (p.$borderColor ? `border: 1px ${p.$borderStyle} ${p.$borderColor};` : '')}
`;

export const BoxedIcon: FC<BoxedIconProps> = ({
  backgroundColor,
  size = VisualSizesEnum.MEDIUM,
  borderStyle = 'solid',
  borderColor,
  ...iconProps
}) => {
  const theme = useUserTheme();
  return (
    <BoxedIconWrapperDiv
      $borderColor={borderColor}
      $backgroundColor={backgroundColor || theme.greys.shade30}
      $borderStyle={borderStyle}
      $size={SIZE_VALUES[size].box}
    >
      <Icon {...iconProps} size={SIZE_VALUES[size].icon} />
    </BoxedIconWrapperDiv>
  );
};
